import type { AgentRun } from "../api/e2e";

type RunRouteIdentity = Pick<
  AgentRun,
  "id" | "company_id" | "model_version_id"
>;

export function companyRunsPath(
  run: Pick<RunRouteIdentity, "company_id">,
): string {
  return `/companies/${encodeURIComponent(run.company_id)}/runs`;
}

export function companyRunPath(
  run: Pick<RunRouteIdentity, "id" | "company_id">,
): string {
  return `${companyRunsPath(run)}/${encodeURIComponent(run.id)}`;
}

export function editRunDraftPath(run: Pick<RunRouteIdentity, "id">): string {
  return `/new?draft=${encodeURIComponent(run.id)}`;
}

export function canonicalRunDestination(run: RunRouteIdentity): string {
  if (!run.model_version_id) return companyRunPath(run);
  return `/companies/${encodeURIComponent(run.company_id)}/models/${encodeURIComponent(run.model_version_id)}?tab=run-details`;
}

export function publishedModelPath(
  run: Pick<RunRouteIdentity, "company_id" | "model_version_id">,
): string | null {
  if (!run.model_version_id) return null;
  return `/companies/${encodeURIComponent(run.company_id)}/models/${encodeURIComponent(run.model_version_id)}?tab=model`;
}
